import {
  Component,
  OnInit,
  AfterContentInit,
  Inject
} from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { PlatformInterface } from '../../../../core/models';

import { MainDashboardInterface } from '../../models';

import { EditSspService } from '../../services';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-edit-ssp-dialog',
  templateUrl: './edit-ssp-dialog.component.html',
  styleUrls: ['./edit-ssp-dialog.component.scss'],
  standalone: false
})
export class EditSspDialogComponent implements OnInit, AfterContentInit {
  private macrosListContentHeight = 'auto';
  private macrosListBodyHeight = 'auto';

  constructor(
    @Inject(NZ_MODAL_DATA) public data: MainDashboardInterface.IEditSSPDialog,
    protected editSspService: EditSspService,
    private dialogRef: NzModalRef<EditSspDialogComponent>,
  ) { }

  public ngOnInit() {
    this.editSspService.initializeComponent(this.data);

    (this.editSspService.editSSPForm.get('isVideo') as FormControl).valueChanges.subscribe(value => {
      this.editSspService.onChangeVideoFormatHandler(value);
    });

    (this.editSspService.editSSPForm.get('isAudio') as FormControl).valueChanges.subscribe(value => {
      this.editSspService.onChangeAudioFormatHandler(value);
    });

    (this.editSspService.editSSPForm.get('rewarded') as FormControl).valueChanges.subscribe(value => {
      this.editSspService.onChangeRewardedFormatHandler(value);
    });

    (this.editSspService.editSSPForm.get('pixalate_pb_settings')?.get('ip') as FormControl).valueChanges.subscribe((value) => {
      this.editSspService.onChangePixalatePreBidIpHandler(value);
    });

    (this.editSspService.editSSPForm.get('pixalate_pb_settings')?.get('ifa') as FormControl).valueChanges.subscribe((value) => {
      this.editSspService.onChangePixalatePreBidIFAHandler(value);
    });

    (this.editSspService.editSSPForm.get('pixalate_pb_settings')?.get('hr_app') as FormControl).valueChanges.subscribe((value) => {
      this.editSspService.onChangePixalatePreBidBundleHandler(value);
    });

    (this.editSspService.editSSPForm.get('is_multi_ad_response') as FormControl).valueChanges.subscribe((value) => {
      if (value) {
        this.editSspService.editSSPForm.get('multi_ad_responses')?.setValue(10);
      } else {
        this.editSspService.editSSPForm.get('multi_ad_responses')?.reset();
      }
    });
  }

  public ngAfterContentInit(): void {
    this.macrosListContentHeight = window.innerHeight - 200 + 'px';
    this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
    window.addEventListener('resize', () => {
      this.macrosListContentHeight = window.innerHeight - 200 + 'px';
      this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
    });
  }

  protected isMediaGuardEnabled(): boolean {
    return this.editSspService.isMediaGuardEnabled();
  }

  protected onChangeTrafficType(_: any): void {
    this.editSspService.onChangeTrafficTypeHandler();
  }

  protected onValidateSpaceForName() {
    this.editSspService.onValidateSpaceForNameHandler();
  }

  protected onChangeTab(tabIndex: number): void {
    this.editSspService.onChangeTabHandler(tabIndex);
  }

  protected onCompanyChange(): void {
    this.editSspService.onCompanyChangeHandler();
  }

  protected isTMTEnabled() {
    return this.editSspService.isTMTEnabled();
  }

  protected isNovoroll() {
    return this.editSspService.isNovoroll();
  }

  protected onChangeSize(id: number): void {
    this.editSspService.onChangeSizeHandler(id);
  }

  protected isBotmanPreBidIsEnabled(): boolean {
    return this.editSspService.isBotmanPreBidIsEnabled();
  }

  protected isBotmanPostBidIsEnabled(): boolean {
    return this.editSspService.isBotmanPostBidIsEnabled();
  }

  protected isFraudSensorEnabled(): boolean {
    return this.editSspService.isFraudSensorEnabled();
  }

  protected isFraudLogixEnabled(): boolean {
    return this.editSspService.isFraudLogixEnabled();
  }

  protected onChangeChecked(value: boolean, element: string): void {
    this.editSspService.onChangeChecked(value, element);
  }

  protected onSubmitForm(): void {
    this.editSspService.onSubmitFormHandler(() => this.dialogRef.close('updated'));
  }

  protected onCloseModal() {
    this.editSspService.onCloseModalHandler(() => this.dialogRef.close());
  }

  protected async onApiLinkTest(link: string, event: MouseEvent): Promise<void> {
    return await this.editSspService.onApiLinkTestHandler(link, event);
  }

  protected onCopyLink(event: MouseEvent, label: string): void {
    this.editSspService.onCopyLinkHandler(event, label);
  }

  protected onChangeCustomAdapter(server: string | number): void {
    this.editSspService.onChangeCustomAdapterHandler(server);
  }

  protected onDeleteEndpoint(endpoint: PlatformInterface.IPlatformSSP) {
    this.editSspService.onDeleteEndpointHandler(endpoint, () => this.dialogRef.close('updated'));
  }

  protected onDuplicateEndpoint(endpointId: number): void {
    this.editSspService.onDuplicateEndpointHandler(endpointId, () => this.dialogRef.close('updated'));
  }

  protected onValidateLink(link: string, event: Event): void {
    this.editSspService.onValidateLinkHandler(link, event);
  }

  protected getError(value: boolean): void {
    this.editSspService.getError(value);
  }

  protected onShowMacrosList(): void {
    this.editSspService.onShowMacrosListHandler(this.macrosListContentHeight, this.macrosListBodyHeight);
  }

  protected onTagTypeChanged(type: string): void {
    this.editSspService.onTagTypeChangeHandler(type);
  }

  protected onChangeMacrosJs(selectedItems: string[]): void {
    this.editSspService.onChangeMacrosJsHandler(selectedItems);
  }

  protected onChangeVastMacros(selectedItems: string[]): void {
    this.editSspService.onChangeVastMacrosHandler(selectedItems);
  }

  protected onShowVastMacros() {
    this.editSspService.onShowVastMacrosesHandler();
  }

  protected sizeChange(selected: string): void {
    this.editSspService.onSizeChangeHandler(selected);
  }

  protected onChangeDefaultBidfloor() {
    this.editSspService.onChangeDefaultBidfloor();
  }

  protected onChangeBCATCheckboxState(value: boolean): void {
    this.editSspService.onChangeBCATCheckboxStateHandler(value);
  }

  protected onPreventInput(event: KeyboardEvent | MouseEvent, field: string): void {
    this.editSspService.onPreventInputHandler(event, field);
  }

  protected onChangeMarginType(type: string): void {
    this.editSspService.onChangeMarginTypeHandler(type);
  }

  protected isRequiredAdapterField(itemName: string): boolean {
    return this.editSspService.getIsRequiredAdapterField(itemName);
  }
}
